// import jsPDF from "jspdf";
import Vue from "vue";
import autoTable from "jspdf-autotable";
import moment from "moment";
import api from "../axios";
// import angkaTerbilang from "@develoka/angka-terbilang-js";
// import { bulkReadInvoice } from "../services/api/invoice";

let skuDivider = {};

const showLoading = () => {
  Vue.prototype.$vs.loading();
};

const hideLoading = () => {
  Vue.prototype.$vs.loading.close();
};

const setPos = (pageWidth, pos, offset) => {
  if (pos >= pageWidth) {
    return pageWidth;
  } else {
    if (pos <= 0) {
      return offset;
    } else {
      return (pos += offset);
    }
  }
};

const generateHeader = (pdf, resp, cursorY, pageWidth, pageHeight, padding) => {
    var img = new Image()
    img.src="data:image/png;base64,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"
    pdf.addImage(img, 'png', 2.5, 5, 45, 20)
    pdf.setFontSize(15);

    pdf.setTextColor('F32013')
    pdf.setFontSize(12);
    pdf.text(
        resp.data.sales_return.Code,
        setPos(pageWidth, cursorY, 50),
        setPos(pageHeight, cursorY, 10),
    );

    cursorY += 4.75;
    
    pdf.setTextColor('#000000')
    pdf.setFontSize(10);
    pdf.text(
        "PT SINARMAS DISTRIBUSI NUSANTARA",
        setPos(pageWidth, cursorY, 45),
        setPos(pageHeight, cursorY, 10)
    );
    
    cursorY += 4.75;

    pdf.setTextColor('#000000')
    pdf.setFontSize(15);
    pdf.text(
        "SURAT PENARIKAN BARANG RETUR (SPBR)",
        setPos(pageWidth, cursorY, 40),
        setPos(pageHeight, cursorY, 10)
    );

    pdf.setFontSize(13);
    // tabel header
    cursorY = generateHeaderInfo(
        pdf,
        resp,
        cursorY,
        pageHeight,
        pageWidth
    ); 

    console.log("cursorY after header", cursorY)

    return cursorY;
};

const generateHeaderInfo = (
    pdf,
    resp,
    cursorY,
    pageHeight,
    pageWidth
    ) => {
    const header = [
      { header: "", dataKey: "title" },
      { header: "", dataKey: "delimiter" },
      { header: "", dataKey: "value" },
      { header: "", dataKey: "title_2" },
      { header: "", dataKey: "delimiter_2" },
      { header: "", dataKey: "value_2" },
    ];
    // tabel header
    /* 
    NPWP              : Npwp SDN                    || No. Faktur         : 
    Sold To           : Sold to Code | Sold to Name || No. Reference      : 
    Nama Customer     : Shipto Contact Name         || Tanggal Retur      : 
    Ship to Address   : Shipto Address              || Driver             : 
    Salesman          : Code | Name                 || Tanggal Penarikan  : 
    */
    const headerData = {
      npwp: resp.data.company.npwp, 
      sold_to: resp.data.customer.code + " | " + resp.data.customer.name, 
      cust_name: resp.data.ship_to.code + " | " + resp.data.ship_to.contact_name, 
      shipto_addr: resp.data.ship_to.address, 
      salesman: resp.data.salesman.ID != 0 ? (resp.data.salesman.CodeExternal + " | " + resp.data.salesman.Name) : (resp.data.created_by.Code + " | " + resp.data.created_by.Name),
      no_faktur: resp.data.invoice_code != "" ? resp.data.invoice_code : " - ", 
      no_reference: resp.data.sales_return.ExternalCode, 
      tgl_retur: formatDate(resp.data.sales_return.Date), 
      driver: "", 
      tgl_tarik: resp.data.sales_return.PickupDate != null ? formatDate(resp.data.sales_return.PickupDate) : "-",
    };
    const body = [
      // { title: "Print", delimiter: ":", value: invoice.PrintCount + 1 },
      { title: "NPWP", delimiter: ":", value: headerData.npwp, 
        title_2: "No. Faktur", delimiter_2: ":", value_2: headerData.no_faktur },
      { title: "Sold To", delimiter: ":", value: headerData.sold_to, 
        title_2: "No. Reference", delimiter_2: ":", value_2: headerData.no_reference },
      { title: "Nama Customer", delimiter: ":", value: headerData.cust_name, 
        title_2: "Tanggal Retur", delimiter_2: ":", value_2: headerData.tgl_retur },
      { title: "Ship to Address", delimiter: ":", value: headerData.shipto_addr, 
        title_2: "Tanggal Penarikan", delimiter_2: ":", value_2: headerData.tgl_tarik },
      { title: "Salesman", delimiter: ":", value: headerData.salesman, 
        title_2: "Driver", delimiter_2: ":", value_2: headerData.driver },
    ];
    pdf.setFont("Times", "Bold");
    autoTable(pdf, {
        startY: cursorY+20,
        columns: header,
        body: body,
        showHead: "never",
        styles: {
          lineWidth: 0,
          fontSize: 9,
          font: "Times",
          fontStyle: "Bold",
          valign: "top",
        },
        columnStyles: {
          title: { cellWidth: 36, cellPadding: 0 },
          delimiter: { cellWidth: 5, cellPadding: 0 },
          value: { cellWidth: 125, cellPadding: 0 },
          title_2: { cellWidth: 36, cellPadding: 0 },
          delimiter_2: { cellWidth: 5, cellPadding: 0 },
          value_2: { cellWidth: 125, cellPadding: 0 },
        },
        theme: "plain",
        margin: {
          left: setPos(pageWidth, (pageWidth / 2 + 4) - 12, 1),
          right: 1,
        },
    });
    
      return pdf.lastAutoTable.finalY;
};

const generateFooter = (pdf, resp, cursorY, pageWidth, pageHeight, padding) => {
  // DPP PPN Grand Total
  // Try manual re-calculate SR on print page.
  // console.log("resp", resp)

  let total = {dpp: 0, totalTax: 0, grandTotal: 0}
  
  // Dpp's
  const totalListPrice = resp.data.sales_return_lines.reduce((acc, item) => {
    if (resp.data.sales_return.InvoiceID != 0) {
      if(item.Info){
        // Ini menandakan SR with Reff enhance
        if(item.Info.allow_return && item.Quantity > 0){
          return acc + (parseFloat(item.SrPrice) * parseFloat(item.Quantity) + (resp.data.sales_return.ReturnTypeStr == '1' ? item.Info.gross_up : 0))
        } 
      } else {
        // Ini SR with Reff yang old, pake Price
        if(item.Price > 0 && item.Quantity > 0){
          return acc + (parseFloat(item.Price) * parseFloat(item.Quantity))
        } else {
          return acc;
        }
      }
    } else {
      return acc + (item.Price * item.Quantity);
    }
  }, 0);

  // total adj price
  const totalAdjPrice = resp.data.sales_return_lines.reduce((acc, item) => {
    return acc + item.AdjPrice * item.Quantity;
  }, 0);

  // total discount
  const totalDiscount = resp.data.sales_return_lines.reduce((acc, item) => {
    if (resp.data.sales_return.InvoiceID != 0){
      if(item.Info){
        if (item.quantity > 0 && item.Info.allow_return){
          item.info.total_disc_fg = item.quantity * item.amount_uom * item.info.disc_fg;
          item.total_discount = item.info.total_disc_fg;
          // return acc + item.info.total_disc_fg;
          return acc;
        } 
      } else {
        return acc
      }
    } else {
      return acc + (item.discount * item.quantity);
    }
  }, 0);

  const usingFloor = checkUsingFloor(resp.data.sales_return.Date);
  // Taxes
  console.log("usingFloor", usingFloor)
  console.log("resp.data.sales_return", resp.data.sales_return)
  if (resp.data.sales_return.InvoiceID != 0){
    /* 
      kalau taxID SR nya tidak null, maka cek Dulu, customer nya IS PKP atau ngga.
      MIX2-5451	
      "PPN yang digunakan tergantung pada customer PKP / Non-PKP dan dapat diubah
      Customer PKP = Include PPN (default PPN mengikuti Invoice Ref)
      Non PKP = Hanya DPP, karena tidak menerbitkan NRP (default No PPN)"
    */
    if(resp.data.sales_return.TaxRate != null && resp.data.sales_return.TaxRate > 0) {
      resp.data.sales_return_lines.forEach((item) => {
        // console.log("item", item)
        let gross_up = item.gross_up != undefined ? item.gross_up : 0;
        item.tax_rate = resp.data.sales_return.TaxRate;
        if(item.Info){
          item.taxAmount = 0
          if (item.Info.allow_return) {
            if(resp.data.sales_return.ReturnTypeStr == "1") {
              item.taxAmount = item.quantity > 0 ?  ( (resp.data.sales_return.TaxRate / 100) * (((item.sr_price * item.quantity)) + gross_up) ) : 0; //taxRate * (qty * price) + grossUp
            } else {
              item.taxAmount = item.quantity > 0 ? ( (resp.data.sales_return.TaxRate / 100) * ((item.sr_price * item.quantity)) ) : 0; //taxRate * (qty * price)
            }
          }
        } else {
          item.taxAmount = item.quantity > 0 ? ( (resp.data.sales_return.TaxRate / 100) * ((item.price * item.quantity)) ) : 0;
        }
        item.taxAmount = usingFloor ? Math.floor( item.taxAmount ) : Math.round( item.taxAmount )
      })
    }
    console.log("resp.data.sales_return_lines", resp.data.sales_return_lines)
  } else {
    // SR Without reff
    resp.data.sales_return_lines.forEach((item, i) => {
      console.log(i, item)
      console.log(resp.data.sales_return_lines[i])
      console.log("resp.data.sales_return_lines.tax", resp.data.sales_return_lines.tax)

      // Pengecekan GenerateTaxInvoice dari taxType terpilih di SKu ini.
      // MIX2-2502379 issue selisih tax di UI dan cetak SPBR
      console.log("item tax", item.tax)
      // console.log("item GenerateTaxInvoice", item.tax.GenerateTaxInvoice)

      // Old ver, ga nge cek generateTaxInv
      console.log("i", i)
      console.log("resp.data.sales_return_lines[i]", resp.data.sales_return_lines[i])
      console.log("item.GenerateTaxInvoice", item.GenerateTaxInvoice)
      // Masih issue kenapa kok Infinit Loop disini
      if(item.TaxRate > 0){
        if(item.TaxRate != undefined && item.TaxRate > 0) {
            resp.data.sales_return_lines[i].TaxAmount = (((item.AdjPrice * item.Quantity)) * (item.TaxRate / 100))
        }
        if(item.taxRate != undefined && item.taxRate > 0) {
            resp.data.sales_return_lines[i].TaxAmount = (((item.AdjPrice * item.Quantity)) * (item.TaxRate / 100))
        }
        if(item.TaxRate != undefined && item.TaxRate == 0) {
          console.log("793 item")
          resp.data.sales_return_lines[i].TaxAmount = (((item.AdjPrice * item.Quantity)) * 0)
        }
      } else {
        console.log("814")
        console.log("815 item", item)
        console.log("item.TaxRate", item.TaxRate)
        
        if(item.TaxRate != undefined && item.TaxRate == 0) {
          resp.data.sales_return_lines[i].TaxAmount = (((item.AdjPrice * item.Quantity)) * 0)
        }
        resp.data.sales_return_lines[i].TaxAmount = (((item.AdjPrice * item.Quantity)) * 0)
      }

      if( usingFloor ){
        resp.data.sales_return_lines[i].TaxAmount = Math.floor( resp.data.sales_return_lines[i].TaxAmount );
      } else {
        resp.data.sales_return_lines[i].TaxAmount = Math.round( resp.data.sales_return_lines[i].TaxAmount );
      }

      console.log("item", item)
    });
    console.log("resp.data.sales_return_lines", resp.data.sales_return_lines)
  }

  // total tax by Lines
  const totalTax = resp.data.sales_return_lines.reduce((acc, item) => {
    item.TaxAmount = usingFloor ? Math.floor( item.TaxAmount ) : Math.round( item.TaxAmount );
    return acc + item.TaxAmount;
  }, 0);

  // Tambah CR-2500051 _ Rounding PPN _ di SR dan rounding Diff
  let totalTaxByDpp = resp.data.sales_return.InvoiceID != 0 ?  (resp.data.sales_return.TaxRate / 100) * totalListPrice  : (resp.data.sales_return.TaxRate / 100) * totalAdjPrice;
  if ( usingFloor ){
    totalTaxByDpp = Math.floor( totalTaxByDpp );
  } else {
    totalTaxByDpp = Math.round( totalTaxByDpp );
  }

  let roundDiff = 0;
  roundDiff = totalTaxByDpp - totalTax;
  console.log("roundDiff", roundDiff)
  console.log("roundDiff != 0 ?", (roundDiff != 0))
 
  const total_line = {
    // Tambah CR-2500051 _ Rounding PPN _ di SR
    // sales_return: resp.data.sales_return.InvoiceID != 0 ? Math.floor(totalTax) + Math.round(totalListPrice) - Math.round(totalDiscount) : totalAdjPrice + totalTax,
    sales_return: roundDiff + (resp.data.sales_return.InvoiceID != 0 ? Math.round(totalTax) + Math.round(totalListPrice) - Math.round(totalDiscount) : totalAdjPrice + totalTax),
    list_price : Math.round(totalListPrice),
    adj_price : Math.round(totalAdjPrice),
    tax : totalTax + roundDiff,
    discount: Math.round(totalDiscount),
  }
  console.log("total_line", total_line)
  
  const headerTotals = [
    { header: "", dataKey: "title" },
    { header: "", dataKey: "delimiter1" },
    { header: "", dataKey: "delimiter2" },
    { header: "", dataKey: "val" },
    { header: "", dataKey: "value1" },
    { header: "", dataKey: "value2" },
  ];
  /*
  const bodyTotals = [
    {title: "", delimiter1 : "",delimiter2: "",val: "", value1: "DPP",value2: formatCurrency(resp.data.sales_return.TotalPrice.toFixed(2))  },
    {title: "", delimiter1 : "",delimiter2: "",val: "", value1: "PPN",value2: formatCurrency(resp.data.sales_return.TotalTax.toFixed(2))  },
    {title: "", delimiter1 : "",delimiter2: "",val: "", value1: "Grand Total",
      value2: (resp.data.sales_return.InvoiceID != null && resp.data.sales_return.InvoiceID != 0) ?
      formatCurrency((resp.data.sales_return.TotalPrice + resp.data.sales_return.TotalTax).toFixed(2)) 
      : formatCurrency(resp.data.sales_return.Total.toFixed(2))
    }
  ];
  */
  const bodyTotals = [
    {title: "", delimiter1 : "",delimiter2: "",val: "", value1: "DPP",value2: formatCurrency(total_line.list_price.toFixed(2))  },
    {title: "", delimiter1 : "",delimiter2: "",val: "", value1: "PPN",value2: formatCurrency(total_line.tax.toFixed(2))  },
    {title: "", delimiter1 : "",delimiter2: "",val: "", value1: "Grand Total",
      value2: (resp.data.sales_return.InvoiceID != null && resp.data.sales_return.InvoiceID != 0) ?
      formatCurrency((total_line.list_price + total_line.tax).toFixed(2)) 
      : formatCurrency(total_line.sales_return.toFixed(2))
    }
  ];
  pdf.setFont("Times", "Bold");
  autoTable(pdf, {
      startY: cursorY,
      columns: headerTotals,
      body: bodyTotals,
      showHead: "never",
      styles: {
        lineWidth: 0,
        fontSize: 10,
        font: "Times",
        fontStyle: "Bold",
        valign: "top",
      },
      columnStyles: {
        title: { cellWidth: 65, cellPadding: 0.1, halign: "center"},
        delimiter1: { cellWidth: 45, cellPadding: 0.1, halign: "center" },
        delimiter2: { cellWidth: 45, cellPadding: 0.1, halign: "center" },
        val: { cellWidth: 45, cellPadding: 0.1, halign: "center" },
        value1: { cellWidth: 45, cellPadding: 0.1, halign: "right" },
        value2: { cellWidth: 45, cellPadding: 0.1, halign: "right" },
      },
      theme: "plain",
      margin: {
        left: setPos(pageWidth, (pageWidth / 2 + 4) - 12, 1),
        right: 1,
      },
  });
  
  const header = [
        { header: "Dibuat Oleh.", dataKey: "title" },
        { header: "Disetujui Oleh.", dataKey: "delimiter" },
        { header: "Diserahkan Oleh.", dataKey: "value" },
        { header: "Diterima Oleh.", dataKey: "value2" },
    ];
    const body = [
      { title: "", delimiter: "", value: "", value2: "" },
      { title: "", delimiter: "", value: "", value2: "" },
      { title: "", delimiter: "", value: "", value2: "" },
      { title: "", delimiter: "", value: "", value2: "" },
    ];
    pdf.setFont("Times", "Bold");
    autoTable(pdf, {
        startY: cursorY+15,
        columns: header,
        body: body,
        showHead: "firstPage",
        headStyles :{lineWidth: 0.5, lineColor: [0, 0, 0], fillColor: 'white', textColor: [0,0,0],halign: "center"},
        styles: {
          lineWidth: 0,
          fontSize: 8,
          font: "Times",
          fontStyle: "Bold",
          valign: "top",
        },
        columnStyles: {
          title: { cellWidth: 50, cellPadding: 0, halign: "center" },
          delimiter: { cellWidth: 95, cellPadding: 0, halign: "center" },
          value: { cellWidth: 95, cellPadding: 0, halign: "center" },
          value2: { cellWidth: 50, cellPadding: 0, halign: "center" },
        },
        theme: "plain",
        margin: {
          left: setPos(pageWidth, (pageWidth / 2 + 4) - 12, 1),
          right: 1,
        },
    });

    // head2
    const header2 = [
        { header: "Dibuat Oleh.", dataKey: "title" },
        { header: "Disetujui Oleh.", dataKey: "delimiter1" },
        { header: "Disetujui Oleh.", dataKey: "delimiter2" },
        { header: "Diserahkan Oleh.", dataKey: "value1" },
        { header: "Diserahkan Oleh.", dataKey: "value2" },
        { header: "Diterima Oleh.", dataKey: "val" },
    ];
    const body2 = [
      // { title: "Print", delimiter: ":", value: invoice.PrintCount + 1 },
      { 
        title       : "Salesman\n\n\n\n\n(            )", 
        delimiter1  : "Supervisor Salesman / DSS\n\n\n\n\n(            )", 
        delimiter2  : "BM / OM\n\n\n\n\n(            )", 
        value1      : "Customer\n\n\n\n\n(            )",  
        value2      : "Driver\n\n\n\n\n(            )", 
        val         : "Checker\n\n\n\n\n(            )" 
    },
      { title: "Tanggal : ", delimiter1: "Tanggal : ", delimiter2: "Tanggal : ", value1: "Tanggal : ",  value2: "Tanggal : ", val: "Tanggal : " },
    ];
    pdf.setFont("Times", "Bold");
    autoTable(pdf, {
        startY: pdf.lastAutoTable.finalY-13,
        columns: header2,
        body: body2,
        showHead: "never",
        headStyles :{lineWidth: 0.3, lineColor: [0, 0, 0], fillColor: 'white', textColor: [0,0,0],halign: "center"},
        styles: {
          lineWidth: 0,
          fontSize: 8,
          font: "Times",
          fontStyle: "Bold",
          valign: "top",
        },
        columnStyles: {
          title: { cellWidth: 50, cellPadding: 1, lineWidth: 0.3, halign: "center", lineColor: [0, 0, 0]},
          delimiter1: { cellWidth: 47.5, cellPadding: 1, lineWidth: 0.3, halign: "center", lineColor: [0, 0, 0] },
          delimiter2: { cellWidth: 47.5, cellPadding: 1, lineWidth: 0.3, halign: "center", lineColor: [0, 0, 0] },
          value1: { cellWidth: 47.5, cellPadding: 1, lineWidth: 0.3, halign: "center", lineColor: [0, 0, 0] },
          value2: { cellWidth: 47.5, cellPadding: 1, lineWidth: 0.3, halign: "center", lineColor: [0, 0, 0] },
          val: { cellWidth: 50, cellPadding: 1, lineWidth: 0.3, halign: "center", lineColor: [0, 0, 0] },
        },
        theme: "plain",
        didParseCell(data) {
            const columnContent = data.cell.raw;
            if (columnContent === "Tanggal : ") {
              data.cell.styles.halign = "left";
            }
        },
        margin: {
          left: setPos(pageWidth, (pageWidth / 2 + 4) - 12, 1),
          right: 1,
        },
    });
    return pdf.lastAutoTable.finalY - 15;
};

const generateShadowHead = (
  pdf,
  data,
  cursorY,
  pageWidth,
  pageHeight,
  padding,
  idx,
  isShowHeader
) => {
  // shadow head
  let startY = cursorY;
  const headerS = [
    { header: "", dataKey: "no", rowSpan: 2 },
    { header: "", dataKey: "sku_name", rowSpan: 2 },
    { header: "", dataKey: "sku_code", rowSpan: 2 },
    { header: "", dataKey: "batch", rowSpan: 2 },
    { header: "", dataKey: "qty", rowSpan: 2 },
    { header: "", dataKey: "hu", rowSpan: 2 },
    { header: "", dataKey: "price", rowSpan: 2 },
    { header: "", dataKey: "grand_total", rowSpan: 2 },
    { header: "", dataKey: "reason", rowSpan: 2 },
    { header: "Status SKU", dataKey: "status1", rowSpan: 2 },
  ];
  const bodyS = {
    no: null,
    sku_name: null,
    sku_code: null,
    batch: null,
    qty: null,
    hu: null,
    price: null,
    adj_price: null,
    tax_amount: null,
    grand_total: null,
    reason: null,
    status1: null,
    status2: null,
    is_with_ref: null
  }
  autoTable(pdf, {
      startY: startY,
      columns: headerS,
      body: [bodyS],
      styles: {
        lineWidth: 0,
        fontSize: 8,
        font: "Times",
        fontStyle: "Bold",
        valign: "middle",
    },
    showHead: idx === 0 || isShowHeader ? "firstPage" : "never",
    headStyles :{lineWidth: 0.3, lineColor: [0, 0, 0], fillColor: 'white', textColor: [0,0,0], halign: 'center'},
    columnStyles: {
        no: { cellWidth: 13, cellPadding: 0, halign: "center", lineWidth: 0.3,lineColor: [0, 0, 0], },
        sku_name: { cellWidth: 57, cellPadding: 0, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0], },
        sku_code: { cellWidth: 25, cellPadding: 0, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0], },
        batch: { cellWidth: 30, cellPadding: 0, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0], },
        qty: { cellWidth: 13, cellPadding: 0, halign: "center", lineWidth: 0.3,lineColor: [0, 0, 0], },
        hu: { cellWidth: 13, cellPadding: 0, halign: "center", lineWidth: 0.3,lineColor: [0, 0, 0], },
        inv_code: { cellWidth: 21, cellPadding: 0, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0], },
        price: { cellWidth: 40.5, cellPadding: 0, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0], },
        sr_price: { cellWidth: 40.5, cellPadding: 0, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0], },
        adj_price: { cellWidth: 40.5, cellPadding: 0, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0], },
        tax_amount: { cellWidth: 26, cellPadding: 0, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0], },
        grand_total: { cellWidth: 35, cellPadding: 0, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0], },
        reason: { cellWidth: 32, cellPadding: 0, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0], },
        status1: { cellWidth: 34, cellPadding: 0, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0], },
    },
    theme: "grid",
    margin: {
      left: setPos(pageWidth, (pageWidth / 2 + 4) - 12, 1),
      right: 1,
    },
  });
  // end of shadow head
  return pdf.lastAutoTable.finalY;
}


const generateSRLines = (
    pdf,
    data,
    cursorY,
    pageWidth,
    pageHeight,
    padding,
    idx,
    isShowHeader
) => {
    const lines = data;
    const header = [
        { header: "No", dataKey: "no", rowSpan: 2 },
        { header: "Nama Barang", dataKey: "sku_name", rowSpan: 2 },
        { header: "No. SKU", dataKey: "sku_code", rowSpan: 2 },
        { header: "No. Produksi \n(Batch)", dataKey: "batch", rowSpan: 2 },
        { header: "Qty", dataKey: "qty", rowSpan: 2 },
        { header: "HU", dataKey: "hu", rowSpan: 2 },
        { header: data.is_with_ref ? "Price" : "Adj. Price", dataKey: data.is_with_ref ? "sr_price" : "adj_price", rowSpan: 2 },
        { header: "Sub Total", dataKey: "grand_total", rowSpan: 2 },
        { header: "Alasan Retur", dataKey: "reason", rowSpan: 2 },
        { header: "Good Stock", dataKey: "status1", rowSpan: 2 },
        { header: "Bad Stock", dataKey: "status2", rowSpan: 2 },
    ];

    let startY = cursorY;
    pdf.setLineWidth(2)
    pdf.setTextColor('#000000')
    pdf.setFont("Times", "Bold")

    autoTable(pdf, {
        startY: startY,
        columns: header,
        body: [data],
        styles: {
            lineWidth: 0,
            fontSize: 10,
            font: "Times",
            fontStyle: "Bold",
            valign: "middle",
        },
        showHead: idx === 0 || isShowHeader ? "firstPage" : "never",
        headStyles :{lineWidth: 0.3, lineColor: [0, 0, 0], fillColor: 'white', textColor: [0,0,0], halign: 'center'},
        columnStyles: {
            no: { cellWidth: 13, cellPadding: 0.5, halign: "center", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            sku_name: { cellWidth: 57, cellPadding: 0.5, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0], textColor: [0, 0, 0]},
            sku_code: { cellWidth: 25, cellPadding: 0.5, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            batch: { cellWidth: 30, cellPadding: 0.5, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            qty: { cellWidth: 13, cellPadding: 0.5, halign: "center", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            hu: { cellWidth: 13, cellPadding: 0.5, halign: "center", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            inv_code: { cellWidth: 21, cellPadding: 0.5, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            sr_price: { cellWidth: 40.5, cellPadding: 0.5, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            price: { cellWidth: 40.5, cellPadding: 0.5, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            adj_price: { cellWidth: 40.5, cellPadding: 0.5, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            tax_amount: { cellWidth: 26, cellPadding: 0.5, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            grand_total: { cellWidth: 35, cellPadding: 0.5, halign: "right", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            reason: { cellWidth: 32, cellPadding: 0.5, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            status1: { cellWidth: 17, cellPadding: 0.5, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0],textColor: [0, 0, 0] },
            status2: { cellWidth: 17, cellPadding: 0.5, halign: "left", lineWidth: 0.3,lineColor: [0, 0, 0], textColor: [0, 0, 0]},
        },
        theme: "grid",
        margin: {
          left: setPos(pageWidth, (pageWidth / 2 + 4) - 12, 1),
          right: 1,
        },
    });

    return pdf.lastAutoTable.finalY;
};
    
const printPDF = async (
  pdf,
  isPrint = true,
  pageWidth,
  pageHeight,
  padding,
  id
) => {
  try {
    showLoading();

    let resp = {};
    console.log("id", id);

    if (id) {
        console.log("id", id);
        // Getdata disini   
        resp = await api.get(`api/v2/sales-return-management/${id}/export/pdf`);
        if (resp.code == 200) {
            console.log(resp);
        } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "error.message",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
        }
    }
    
    pdf.setFontSize(13);
    pdf.setFont("Times", "Bold");

    const startPoint = 1;
    let cursorY = startPoint;
    let key = 1;
    let currentPage = 1;

    cursorY = generateHeader(pdf, resp, cursorY, pageWidth, pageHeight, padding);
    cursorY += 7.5
    // cursorY = generateSRLineHead1()
    // cursorY = generateSRLineHead2()
    console.log("cursorY after header + jarak margin, start draw Table ", cursorY)

    let body = resp.data.sales_return_lines.map((lines, idx) => {
        return {
            no: idx+1,
            sku_name: lines.ItemName,
            sku_code: lines.ItemCode,
            batch: lines.Batch,
            qty: lines.Quantity,
            hu: lines.ItemUnit,
            inv_code: lines.invoice_code,
            price: formatCurrency(lines.Price.toFixed(2)),
            sr_price: formatCurrency(lines.SrPrice != undefined && lines.Info != undefined ? lines.SrPrice.toFixed(2) : lines.Price.toFixed(2) ),            
            // MIX2-2503080_fix-SR-print
            // sr_price: formatCurrency(lines.SrPrice != undefined && lines.Info != undefined ? lines.SrPrice.toFixed(2) : lines.Price.toFixed(2) ),
            adj_price: formatCurrency(lines.AdjPrice.toFixed(2)),
            tax_amount: formatCurrency(lines.TaxAmount.toFixed(2)),
            grand_total: formatCurrency(lines.Total.toFixed(2)),
            reason: lines.Reason,
            status1: "",
            status2: "",
        };
    });

    // let Testbody = []
    // for (let i = 0; i < body.length; i++) {
    //   Testbody.push(body[i])
    // }
    // for (let i = 0; i < body.length; i++) {
    //   Testbody.push(body[i])
    // }

    // console.log("Testbody", Testbody);
    // console.log("prepared body", body);

    let chgPageIndex = 0
    let showHead = true
    // console.log("cursorY Init ", cursorY)
    // if(i > 7) {continue}
    // for (let i = 0; i < Testbody.length; i++) {
    for (let i = 0; i < body.length; i++) {
        // if(i > 6) {continue}
        if (i == 0) {
          cursorY = generateShadowHead(
            pdf,
            body[i],
            // Testbody[i],
            cursorY,
            pageWidth,
            pageHeight,
            padding,
            i,
            showHead
          )
          cursorY -= 5;
        }
        
        body[i].is_with_ref = resp.data.invoice_code != "" ? true : false;
        
        // Testbody[i].is_with_ref = resp.data.invoice_code != "" ? true : false;
        // Testbody[i].sku_name += "_"+cursorY
        // Testbody[i].batch += "width_"+pdf.internal.pageSize.getWidth()+"_height_"+pdf.internal.pageSize.getHeight()
        cursorY = generateSRLines(
          pdf,
          body[i],
          // Testbody[i],
          cursorY,
          pageWidth,
          pageHeight,
          padding,
          i,
          showHead
        );
        
        showHead = false;

        console.log("i", i)
        console.log("chgPageIndex", chgPageIndex)
        console.log("pageHeight", pageHeight)
        console.log("cursorY after render col", cursorY)
        console.log("i-chgPageIndex", ((i - (chgPageIndex))))
        console.log("i-chgPageIndex", ((i - (chgPageIndex))))
        console.log("pageHeight * ichgpage", ((pageHeight * (i - (chgPageIndex)))))
        console.log("jarak", (cursorY-(pageHeight * (i - (chgPageIndex)))))
        
        // console.log("page ke ? ", pdf.internal.getNumberOfPages())
        // console.log("body i ", i, body[i])

        if((cursorY + 50) > pdf.internal.pageSize.getHeight() - 40){
            console.log("ganti page");
            pdf.addPage();
            pdf.setPage(pdf.internal.getNumberOfPages());
            cursorY = 1;
            chgPageIndex = i
            cursorY = generateHeader(pdf, resp, cursorY, pageWidth, pageHeight, padding);
            cursorY += 7.5    
            showHead = true;
            cursorY = generateShadowHead(
              pdf,
              body[i],
              cursorY,
              pageWidth,
              pageHeight,
              padding,
              i,
              showHead
            )
        }
    }        

    cursorY += 1.5
    cursorY = generateFooter(pdf, resp, cursorY, pageWidth, pageHeight, padding);
    cursorY = generateFooterInfo(pdf, resp, cursorY, pageWidth, pageHeight, padding);

    if (isPrint) {
        hideLoading();
        const url = pdf.output("blob");
        const urlObject = URL.createObjectURL(url);
        return urlObject;
    } else {
        hideLoading();
        const url = pdf.output("dataurlstring") + "#toolbar=0";
        return url;
    }
  } catch (error) {
    console.error(error);
    throw new Error("Failed to print PDF");
    // Vue.prototype.$store.commit("arInvoice/resetInvoice");
  }
};

const formatCurrency = (nominal) => {
  if(nominal && nominal > 0) { // nominal > 0 untuk handle return NaN
      nominal = (nominal/1).toFixed(2).replace('.', ',');
      nominal = nominal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      return "Rp. " + nominal;
  } else {
      return 0;
  }
};

const formatDate = (utcStr) => {
  const momentDate = moment.utc(utcStr);
  return momentDate.format("DD.MM.YYYY");
};

const generateFooterInfo = (
  pdf,
  resp,
  cursorY,
  pageHeight,
  pageWidth
  ) => {
  const header = [
    { header: "", dataKey: "title" },
  ];
  
  const body = [
    { title: "Keterangan" },
    { title: "Rangkap 1 Disimpan Oleh Admin AR" },
    { title: "Rangkap 2 Diserahkan ke Adm Gudang (3PL) / Adm Sales" },
    { title: "Rangkap 3 Disimpan oleh Customer" },
  ];
  autoTable(pdf, {
      startY: cursorY+20,
      columns: header,
      body: body,
      showHead: "never",
      styles: {
        lineWidth: 0,
        fontSize: 8,
        font: "Times",
        fontStyle: "Bold",
        valign: "top",
      },
      columnStyles: {
        title: { cellWidth: 80, cellPadding: 0 },
      },
      theme: "plain",
      margin: {
        left: setPos(pageWidth, (pageWidth / 2 + 4) - 12, 1),
        right: 1,
      },
  });
  
    return pdf.lastAutoTable.finalY;
};

const checkUsingFloor = ( srDateUtc ) => {
  let SrDate = moment.utc(srDateUtc);
  SrDate = SrDate.format("YYYY-MM-DD");
  
  var new_year = new Date("2026-01-01");
  new_year = moment(new_year).format("YYYY-MM-DD")
  
  console.log("new_year", new_year)
  console.log("SrDate", SrDate)
  console.log("new_year > SrDate", (new_year > SrDate))
  
  let isUsingFloor = (new_year > SrDate);
  console.log("isUsingFloor", isUsingFloor);
  return isUsingFloor;
};

export default {
  printPDF,
};
